import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useDivisionFromQuery } from "../hooks/useDivisionFromQuery";

export default function TalkingPointsPage() {
  useDivisionFromQuery();
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="app-container">
      <Header />

      <main className="main-content content-page">
        <h2>Helpful Talking Points</h2>

        <p className="intro">
          Proper Wild is the cleanest energy product on the market and is
          offering people a chance to win $20,000 AND try it for free! This is a
          once in a lifetime opportunity to win big and try a new energy product
          for free! While helping your store win $$$!
        </p>

        <div className="talking-points-section">
          <h3>What is Proper Wild?</h3>
          <ul className="talking-points">
            <li>
              Proper Wild is a plant-based energy shot that provides clean,
              sustained energy & focus with reduced crash & jitters
            </li>
            <li>
              Made with organic caffeine from green tea (100mg per shot - equal
              to 2 shots of espresso or one cup of coffee) and 120mg of
              L-theanine for focus & calm
            </li>
            <li>
              Made with fruit juices and nothing artificial. Vegan. Gluten-free.
              Non-GMO.
            </li>
          </ul>
        </div>

        <div className="talking-points-section">
          <h3>Key Benefits to Highlight</h3>
          <ul className="talking-points">
            <li>
              <strong>Clean Energy:</strong> Reduced jitters and crash thanks to
              L-theanine, which promotes calm, focused energy
            </li>
            <li>
              <strong>Quick & Convenient:</strong> Small 2.5oz shot provides
              energy within 15 minutes that lasts 4-6 hours
            </li>
            <li>
              <strong>Healthier Alternative:</strong> Unlike traditional energy
              drinks, no artificial sweeteners or synthetic caffeine
            </li>
            <li>
              <strong>Vegan & GMO-Free:</strong> Made with organic, plant-based
              ingredients - appeals to health-conscious shoppers
            </li>
            <li>
              <strong>Try for free:</strong> Customers get reimbursed for their
              first shot by submitting their receipt to the text number that
              they can sign up for at{" "}
              <a
                href="https://properwild.com/freeshot"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://properwild.com/freeshot
              </a>
            </li>
          </ul>
        </div>

        <div
          className="accordion-header"
          onClick={() => setIsExpanded(!isExpanded)}
          style={{
            cursor: "pointer",
            padding: "1rem",
            backgroundColor: "#f5f5f5",
            borderRadius: "8px",
            marginTop: "1rem",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h3 style={{ margin: 0 }}>View more talking points</h3>
          <span style={{ fontSize: "1.5rem" }}>{isExpanded ? "−" : "+"}</span>
        </div>

        {isExpanded && (
          <>
            <div className="talking-points-section">
              <h3>Who Should Try Proper Wild?</h3>
              <ul className="talking-points">
                <li>
                  <strong>Busy professionals</strong> who need quick energy with
                  nothing artificial
                </li>
                <li>
                  <strong>Students</strong> looking for focused study energy
                </li>
                <li>
                  <strong>Athletes & fitness enthusiasts</strong> wanting clean
                  pre-workout fuel
                </li>
                <li>
                  <strong>Parents</strong> who need an energy boost without the
                  downsides of artificial energy drinks
                </li>
                <li>
                  <strong>Anyone</strong> who wants to replace artificial energy
                  drinks with a healthier option
                </li>
              </ul>
            </div>

            <div className="talking-points-section">
              <h3>Helpful Openers</h3>
              <ul className="talking-points">
                <li>Want a free clean energy & focus shot?</li>
                <li>Free clean energy shot</li>
                <li>
                  Connect with small talk and mix in the free - Need a boost? We
                  have a promo running
                </li>
              </ul>
            </div>

            <div className="talking-points-section">
              <h3>Sample Conversation Starters</h3>
              <div className="conversation-examples">
                <div className="conversation-item">
                  <p className="customer-type">
                    <strong>For the coffee drinker:</strong>
                  </p>
                  <p className="talking-point">
                    "Try a free coffee alternative. Longer lasting energy than
                    coffee with reduced crash & jitters. Looking for an
                    alternative to coffee? Proper Wild has the same caffeine as
                    1 cup, but with added L-theanine for smooth, focused energy
                    for up to 6 hours."
                  </p>
                </div>

                <div className="conversation-item">
                  <p className="customer-type">
                    <strong>For the health-conscious shopper:</strong>
                  </p>
                  <p className="talking-point">
                    "Just caffeine and fruit juice. 100% plant based. Vegan.
                    Nothing artificial. Way cleaner than traditional energy
                    drinks."
                  </p>
                </div>

                <div className="conversation-item">
                  <p className="customer-type">
                    <strong>For the busy customer:</strong>
                  </p>
                  <p className="talking-point">
                    "Need a quick energy boost? This small shot gives you 4-6
                    hours of energy in a couple of sips. Plus you'll feel it
                    within 15 minutes."
                  </p>
                </div>

                <div className="conversation-item">
                  <p className="customer-type">
                    <strong>For the afternoon slump:</strong>
                  </p>
                  <p className="talking-point">
                    "Feeling that afternoon crash? Proper Wild's L-theanine
                    combination makes it easier to fall asleep at night."
                  </p>
                </div>

                <div className="conversation-item">
                  <p className="customer-type">
                    <strong>For the energy drink/shot skeptic:</strong>
                  </p>
                  <p className="talking-point">
                    "Proper Wild is not like other energy shots or drinks. It
                    has 100mg of caffeine (1 cup of coffee), which is about half
                    of what energy drinks have. This means you won't get as
                    jittery or have the same intense feeling. No artificial
                    ingredients or sweeteners like Sucralose which can cause gut
                    issues."
                  </p>
                </div>
              </div>
            </div>

            <div className="talking-points-section">
              <h3>How to Encourage App Redemptions</h3>
              <ul className="talking-points">
                <li>
                  Have people scan the QR code on your postcard or on the POS
                  materials we provided. If they submit their receipt, they will
                  be reimbursed."
                </li>
                <li>
                  Point out any in-store signage about the redemption process
                </li>
                <li>
                  Explain they just text a photo of the receipt and will be
                  reimbursed by PayPal or Venmo. Plus automatically are entered
                  for a chance to win $20,000!
                </li>
                <li>
                  Every 5th shot is free. Plus every shot they redeem
                  automatically enters them for a chance to win $20,000! And
                  helps you win prizes!
                </li>
              </ul>
            </div>

            <div className="tips-callout">
              <h3>💡 Pro Tips for Success</h3>
              <ul>
                <li>
                  Keep Proper Wild products visible and at eye level near the
                  checkout
                </li>
                <li>
                  Try the product yourself so you can speak authentically.
                  Remember you will also be reimbursed if you sign up and submit
                  a photo of the receipt
                </li>

                <li>
                  Share your personal experience: "I use these instead of my
                  afternoon coffee"
                </li>
                <li>
                  Build rapport first, then suggest products based on customer
                  needs
                </li>
                <li>
                  Track your daily redemptions on the leaderboard and celebrate
                  small wins!
                </li>
              </ul>
            </div>
          </>
        )}
      </main>

      <Footer />
    </div>
  );
}
